import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-907d684a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"stake-staked-validators__header\" data-v-907d684a><div class=\"stake-staked-validators__table-item\" data-v-907d684a>Validator</div><div class=\"stake-staked-validators__table-item\" data-v-907d684a>Status</div><div class=\"stake-staked-validators__table-item\" data-v-907d684a>Commission</div><div class=\"stake-staked-validators__table-item\" data-v-907d684a>Total stake</div><div class=\"stake-staked-validators__table-item\" data-v-907d684a>Bonded amount</div></div>", 1)

import StakeStakedValidatorItem from "./stake-staked-validator-item.vue";
import { computed, PropType } from "vue";
import { Validator } from "@/types/staking";
import BigNumber from "bignumber.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-staked-validators',
  props: {
  validators: {
    type: Object as PropType<Array<Validator>>,
    default: null,
  },
  bondedAmount: {
    type: Object as PropType<BigNumber>,
    default: new BigNumber(0),
  },
},
  setup(__props) {

const props = __props;



const dividedAmount = computed(() => {
  return props.bondedAmount.div(props.validators?.length || 1).toNumber();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.validators, (item, index) => {
      return (_openBlock(), _createBlock(StakeStakedValidatorItem, {
        key: index,
        validator: item,
        "approx-bonded-amount": dividedAmount.value
      }, null, 8, ["validator", "approx-bonded-amount"]))
    }), 128))
  ], 64))
}
}

})